// client/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('/firebase-messaging-sw.js')
//     .then((registration) => {
//       console.log('Service Worker registered:');// registration);
//     })
//     .catch((err) => {
//       console.error('Service Worker registration failed:', err);
//     });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', {
      updateViaCache: 'none'  // ← add this line
    })
    .then((registration) => {
      console.log('Service Worker registered:');
    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });

  // ← add this block
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

reportWebVitals();
